class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  connectedCallback() {
    this.addEventListener('click', (evt) => {
      const giftWrappingElement = evt.target.closest('.gift-wrapping');
      if (giftWrappingElement) {
        const id = giftWrappingElement.getAttribute('data-id');
        const isGiftAdded = giftWrappingElement.classList.contains('active') ? 'true' : 'false';
        this.addOrRemoveGift(id, isGiftAdded);
      }
    });

    if (window.location.pathname == '/cart') {
      this.open();
      const cartItems = document.querySelector('cart-items');
      cartItems.closest('main').classList.add('is-cart-drawer');
      this.fromCart = true;
    }
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');
  }

  close() {
    if (this.fromCart) window.location.replace('/');
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    const cartLink = document.querySelector('#cart-icon-bubble');
    const cartLinkIcon = cartLink.dataset.cartIcon;
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    if (cartLinkIcon == 'icon-basket') {
      let svgHTML = document.getElementById('hiddenSvg').innerHTML;
      let currentSvg = cartLink.querySelector('svg');
      currentSvg.innerHTML = svgHTML;
    }

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  async changeGiftItemQuantity() {
    const cartItems = this.querySelector('cart-items') || this.querySelector('cart-drawer-items');
    const cartGiftInput = document.querySelector('input[data-gift-id]');
    const giftIndex = cartGiftInput.dataset.index;

    cartItems.updateQuantity(giftIndex, 0);
  }

  async addOrRemoveGift(id, isGiftAdded) {
    const giftWrappingSvg = document.querySelector(".gift-wrapping svg");
    giftWrappingSvg.classList.toggle("hide_checkbox");
    if (isGiftAdded == 'false') {
      await this.addGiftItem(id);
      return;
    }
    
    await this.changeGiftItemQuantity();
  }

  async addGiftItem(id) {
    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    const depositGiftData = new FormData();
    depositGiftData.append('id', id);
    depositGiftData.append('quantity', 1);
    depositGiftData.append('sections', this.getSectionsToRender().map((section) => section.id));

    config.body = depositGiftData;

    fetch(`${routes.cart_add_url}`, config)
      .then((giftResponse) => giftResponse.json())
      .then((giftResponse) => {
        if (giftResponse.status) {
          console.error('Could not add gift', giftResponse);
        } else {
          this.renderContents(giftResponse);
        }
      })
      .catch((e) => {
        console.error("Cart drawer is not available.");
      }
    );
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

class CartDrawerShippingSavingBar extends CartItems {
  constructor() {
    super();
  }

  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-shipping-saving'
      }
    ];
  }
}

customElements.define('cart-drawer-shipping-saving', CartDrawerShippingSavingBar)


/* Shipping Reservation - TODO - Use Singleton class pattern to manage a global state */
let globalIntervalId = null;
let activeInstances = 0;

class ShippingReservation extends HTMLElement {
  constructor() {
    super();
    activeInstances++;

    const currentTime = new Date().getTime();
    const expirationTimestamp = localStorage.getItem('sr_expirationTimestamp');

    if (this.shouldHideCountdown(currentTime, expirationTimestamp)) {
      this.style.display = 'none';
      return;
    }

    const countdownTime = this.getAttribute('data-time-countdown') || 15;
    const { minutes, seconds } = this.getInitialTime(countdownTime);

    this.state = {
      minutes,
      seconds,
      countdownElement: this.querySelector('.shipping-reservation__time-countdown')
    };
  }

  connectedCallback() {
    if (globalIntervalId === null) {
      this.startGlobalTimer();
    }
  }

  disconnectedCallback() {
    activeInstances--;
    if (activeInstances <= 0) {
      clearInterval(globalIntervalId);
      globalIntervalId = null;
      this.clearLocalStorage();
    }
  }

  shouldHideCountdown(currentTime, expirationTimestamp) {
    return expirationTimestamp && currentTime - expirationTimestamp < 86400000;
  }

  getInitialTime(countdownTime) {
    let minutes = parseInt(countdownTime, 10);
    let seconds = 0;

    const savedTime = localStorage.getItem('sr_savedTime');
    const savedTimestamp = localStorage.getItem('sr_savedTimestamp');

    if (savedTime && savedTimestamp) {
      const currentTime = new Date().getTime();
      const elapsedTime = Math.floor((currentTime - savedTimestamp) / 1000);
      const remainingTime = savedTime - elapsedTime;

      minutes = Math.floor(remainingTime / 60);
      seconds = remainingTime % 60;
    }

    return { minutes, seconds };
  }

  updateCountdown() {
    let { minutes, seconds, countdownElement } = this.state;

    const formattedMinutes = String(minutes).padStart(2, '0');
    const formattedSeconds = String(seconds).padStart(2, '0');

    countdownElement.textContent = `${formattedMinutes}:${formattedSeconds}`;

    if (seconds <= 0) {
      if (minutes <= 0) {
        this.clearLocalStorage();
        this.style.display = 'none';
        return;
      } else {
        minutes--;
        seconds = 59;
      }
    } else {
      seconds--;
    }

    const remainingTime = minutes * 60 + seconds;
    localStorage.setItem('sr_savedTime', remainingTime);
    localStorage.setItem('sr_savedTimestamp', new Date().getTime());

    this.state = { minutes, seconds, countdownElement };
  }

  startGlobalTimer() {
    globalIntervalId = setInterval(() => {
      const instances = document.querySelectorAll('shipping-reservation');
      instances.forEach(instance => instance.updateCountdown());
    }, 1000);
  }

  clearLocalStorage() {
    localStorage.removeItem('sr_savedTime');
    localStorage.removeItem('sr_savedTimestamp');
    localStorage.removeItem('sr_expirationTimestamp');
  }
}

customElements.define('shipping-reservation', ShippingReservation);
